export const FIELD_REGEX = /^[\p{L}0-9\-#&().,;:°'/ ]+$/u;
export const CITY_REGEX = /^[\p{L}0-9\-&().,;'/ ]+$/u;
export const POSTCODE_REGEX = /^[A-Z0-9\- ]+$/i;

export const POSTAL_CODE_MIN_LENGTH = 3;
export const POSTAL_CODE_MAX_LENGTH = 9;

export const ADDRESS_LINE_1_MIN_LENGTH = 2;
export const ADDRESS_LINE_1_MAX_LENGTH = 30;
